(function ( $ ) {

    $.fn.newsRest = function() {
        var that = this;
        var category = that.data('category');
        var template = null;
        var args = { 
            'posts_per_page': 6,
            'page': 0, 
            'category': category,
        }

        function hideButton() {
            $('.js-load-more').addClass('hide');
        }

        function showButton() {
            $('.js-load-more').removeClass('hide');
        }

        $('.js-load-more').on('click', function() {
            args.page = args.page + 1;
            getNews(false);
        })

        function getNews(replace) {
            $.ajax({
                type: 'GET',
                url: window.location.origin + '/wp-json/5x5/v1/news',
                data: args,
                success: function (res) {
                    $.get({
                        url: '/wp-content/themes/5x5/templates/news.html',
                        success: function(html) {
                            template = Handlebars.compile(html);
    
                            items = template({
                                items: res.news
                            })
                            if(res.total > args.posts_per_page) {
                                showButton();
                            } else {
                                hideButton();
                            }
                            if(replace){
                                that.html(items);
                            }
                            else {
                                that.append(items);
                            }
                            setIntersections();
                            initToShow();
                        },
                        error: function(err) {
                            console.log(err);
                        }
                    })
                },
            })
        }

        getNews(true);

    }
}( jQuery ));

$(function() {
    if ($('#js-news').length) {
        $('#js-news').newsRest();
    }
});
